// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, maybe } from "@altostra/type-validations";
import { any, number, string, boolean } from "@altostra/type-validations/lib/primitives";

export const isEngagementPresetIamTemplatesResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      id: string,
      name: string,
      description: string,
      profile_type: number,
      marked_as_deleted: boolean,
      grapes_js_data: maybe(any, true),
      dnd_display_type: maybe(string, true),
      static_template: boolean,
      html: maybe(any, true),
    })
  ),
});
